import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { useAuth } from './contexts/AuthContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import Navigation from './components/Navigation';
import Home from './components/home/Home';
import Branding from './components/domains/Branding';
import { Workspaces } from './components/workspaces/Workspaces';
import { ShortLinks } from './components/shortlinks/ShortLinks';
import { Toaster } from './ui/sonner';
import config from './utils/config';

// Redirect component for deprecated admin routes
function AdminRedirect({ path }: { path: string }) {
  useEffect(() => {
    window.location.href = `${config.authServiceAdminUrl}${path}`;
  }, [path]);

  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <p className="text-muted-foreground">Redirecting to admin portal...</p>
    </div>
  );
}


function App(): JSX.Element {
  const { loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="App">
        <div className="App-header">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <Toaster position="bottom-right" />
      <Router>
        <PermissionsProvider>
          <div className="App">
            <Navigation/>
            <main className="App-main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/branding" element={<Branding />} />
                <Route path="/workspaces" element={<Workspaces/>} />
                <Route path="/manage" element={<ShortLinks/>} />
                {/* User and OAuth client management moved to centralized AuthService admin portal */}
                <Route path="/users" element={<AdminRedirect path="/users" />} />
                <Route path="/api-clients" element={<AdminRedirect path="/oauth-clients" />} />
              </Routes>
            </main>
          </div>
        </PermissionsProvider>
      </Router>
    </div>
  );
}

export default App;
